export function isPaginatedSortBy(sortBy) {
  return !(
    sortBy === 'BEST_SELLING' ||
    sortBy === 'RECOMMENDATIONS' ||
    sortBy === 'HIGHEST_RATED'
  );
}

export const sortIdToTrackingValue = {
  DEFAULT: 'Default',
  PRICE_ASC: 'Low To High',
  PRICE_DESC: 'High To Low',
  BEST_SELLING: 'Best Selling',
  BEST_SELLING_REFILLS: 'Best Selling',
  RECOMMENDATIONS: 'Recommended',
  HIGHEST_RATED: 'Top Rated',
};

const LOGGED_OUT_USER_SORTS = [
  { id: 'PRICE_ASC', name: 'Price: Low to High' },
  { id: 'PRICE_DESC', name: 'Price: High to Low' },
  { id: 'BEST_SELLING_REFILLS', name: 'Best Selling' },
  { id: 'HIGHEST_RATED', name: 'Top Rated' },
];

const LOGGED_IN_USER_SORTS = [
  { id: 'DEFAULT', name: 'Default' },
  { id: 'PRICE_ASC', name: 'Price: Low to High' },
  { id: 'PRICE_DESC', name: 'Price: High to Low' },
  { id: 'BEST_SELLING', name: 'Best Selling' },
  { id: 'HIGHEST_RATED', name: 'Top Rated' },
  { id: 'RECOMMENDATIONS', name: 'Recommendations' },
];

export const getSortValues = (loggedIn) =>
  loggedIn ? LOGGED_IN_USER_SORTS : LOGGED_OUT_USER_SORTS;
